module.exports = __webpack_public_path__ + "static/media/practofexc2020.2ed8f13f.png";